import apiRequest from "../../functions/api";

export const fetchMeldungHistorie = (client, accessToken, program, userId, fetchAll=false) => {
    return new Promise((resolve, reject) => {
        const payload = {
            mandant: client,
            program,
            statement: "MELDUNGS_HISTORIE_HOLEN",
            userId,
            fetchAll
        };
        const headers = {
            Authorization: "Bearer " + accessToken,
        };
        apiRequest("POST", "daten", payload, headers, (response) => {
            if (response.status === 200) {
                resolve(response.data.belegmeldungen);
              } else {
                if (response) {
                  reject(response.data.message);
                } else {
                  reject("Keine Internetverbindung");
                }
              }
            resolve();
        }, () => {
            reject("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
        });
    });
}